import _ from 'underscore';
import { http, odata } from '@bingads-webui/http-util';

export const signOutOnTokenExpire = (e, signOutUrl) => {
  if (e && e.status === 401) {
    window.location.href = signOutUrl;
  }
};

export const wrapOptionsOfODataMethods = (options = {}) =>
  _.defaults({
    error: (xhr, textStatus, errorThrown) => {
      if (xhr && xhr.status === 401 && options.SignOutUrl) {
        window.location.href = options.SignOutUrl;
      }
      if (options.error) {
        options.error(xhr, textStatus, errorThrown);
      }
    },
  }, options);

export const addOptionsToODataMethod = methodName =>
  (...args) => {
    const [url, options, cb] = http.signature(args);

    return odata[methodName](url, wrapOptionsOfODataMethods(options), cb);
  };

export const wrappedOdata = _.defaults({
  get: addOptionsToODataMethod('get'),
  post: addOptionsToODataMethod('post'),
  put: addOptionsToODataMethod('put'),
  patch: addOptionsToODataMethod('patch'),
  delete: addOptionsToODataMethod('delete'),
}, odata);
